import AXIOS from "@/axios";
import axios, { AxiosResponse } from "axios";

export interface LoginResponse {
  message?: string;
  data: {
    token: string;
    username: string;
    name: string;
    roles: {
      code: string;
      permissions: string[];
    }[];
    school_id?: string;
    teacher_id?: string;
    student_id?: string;
    user_id?: string;
    school_ids?: string[]; // Add school_ids to the response data
    schools?: any[]; // Add schools to the response data for the school list

    counts?: {
      active: {
        general_assignment: string;
        unit_assignment: string;
        query: string;
      };
      total: {
        assignment: string;
        query: string;
      };
    };
  };
}

export interface LogoutResponse {
  message: string;
}

export interface ForgotPasswordResponse {
  message: string;
  data: {
    is_email_sent: boolean;
    id: string;
    sent: string;
  };
}

export interface OTPValidationResponse {
  message: string;
  data: {
    id: string;
    verified: boolean;
  };
}

export interface GetAllRolesResponse {
  id: string;
  name: string;
}

export const loginService = async (
  username: string,
  password: string,
  addInfo: any
) => {
  const body = {
    username,
    password: btoa(password),
    addinfo: addInfo,
  };

  return axios.post<AxiosResponse<LoginResponse>>(
    `${import.meta.env.VITE_BASE_URL}/auth/api/v1/login`,
    body
  );
};

export const getSelfService = async () => {
  return AXIOS.get<AxiosResponse<LoginResponse>>("/auth/api/v1/self");
};

export const logoutService = async () => {
  return AXIOS.get<AxiosResponse<LogoutResponse>>("/auth/api/v1/logout");
};

// export const getAllRolesService = async () => {
//   return AXIOS.get<GetAllRolesResponse[]>("/base/dn/v1/role");
// };

export const forgotPasswordService = async (email: string) => {
  return axios.post<ForgotPasswordResponse>(
    `${import.meta.env.VITE_BASE_URL}/auth/api/v1/password/link`,
    { username: email }
  );
};

export const otpValidationService = async (id: string, otp: string) => {
  return axios.post<AxiosResponse<OTPValidationResponse>>(
    `${import.meta.env.VITE_BASE_URL}/auth/api/v1/password/otp`,
    { otp: btoa(otp), id }
  );
};

export const resendOtpService = async (id: string) => {
  return axios.post<AxiosResponse<OTPValidationResponse>>(
    `${import.meta.env.VITE_BASE_URL}/auth/api/v1/resend/otp`,
    { id }
  );
};

export const registerService = async (username: string) => {
  return axios.post<AxiosResponse<ForgotPasswordResponse>>(
    `${import.meta.env.VITE_BASE_URL}/auth/api/v1/register`,
    { username }
  );
};

export const resetPasswordService = async (token: string, password: string) => {
  return axios.post<{ message: string }>(
    `${import.meta.env.VITE_BASE_URL}/auth/api/v1/password/reset`,
    { password: btoa(password) },
    {
      headers: {
        Authorization: `Token ${token}`,
      },
    }
  );
};
